:host {
  display: block;
  max-width: 100%;
}

.section-title {
  color: var(--chart-300-icon-buttons);
}

gz-labeled-content {
  --label-width-percentage: 37%;
  --value-width-percentage: 63%;
}

gz-labeled-content::part(content) {
  color: var(--main-titles-inputs-600);
  font-size: var(--body-size);
}

gz-labeled-content[class*='wrapped']::part(content) {
  white-space: normal;
}

gz-search-query {
  --monaco-scrollable-element-width: -webkit-fill-available;
  --monaco-padding-right: 0;
  --font-family: 'IBMPlex', serif;
  --monaco-monospace-font: 'IBMPlex', serif;
  --placeholder-postion-left: 63px;
  --error-border-color: var(--chart-101-pressed-dividers);
  --active-border-color: var(--chart-101-pressed-dividers);
  --hover-border-color: var(--chart-101-pressed-dividers);
}

gz-link[class*='view-alerts']::part(container),
gz-link[class*='view-incidents']::part(container) {
  padding: 0;
}

.actions-in-order {
  padding-top: calc(var(--spacer) * 1.5);
}

.automatic-actions-text {
  padding-top: calc(var(--spacer) * 1.5);
  font-size: var(--body-size);
}

.separator {
  display: inline-block;
  position: relative;
  box-sizing: content-box;
  height: 11px;
  top: 2px;
  width: 1px;
  margin: 0 calc(var(--spacer) * 0.5) 0 calc(var(--spacer) * 1);
  background-color: var(--chart-101-pressed-dividers);
}

//mozilla
@supports (-moz-appearance: none) {
  gz-search-query {
    --monaco-scrollable-element-width: -moz-available;
  }
}

//safari
@supports (background: -webkit-named-image(i)) {
  gz-search-query {
    --monaco-scrollable-element-width: calc(100% - 30px);
  }
}
